import { startTransition } from "react";
import { Box } from '@mui/material';
import { useAppState } from 'src/state-management/state-provider';
import { useSnackbar } from 'src/view/components/SnackbarService';
import FullPageMessage from 'src/view/components/FullPageMessage';
import FullPageLoader from 'src/view/components/FullPageLoader';
import clientService from 'src/clientService';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SubscriptionLock from 'src/view/components/SubscriptionLock';
import { Home } from '@mui/icons-material';
import { ProjectStatusEnum } from "src/api/Api";


const BiodiversityCreditDetail = () => {
  const { id } = useParams<{ id: string; siteId: string }>(); // Get ID from route params
  const { showSnackbar, snackbarType } = useSnackbar();
  const { state, dispatch } = useAppState();
  const { selectedProject } = state;
  const { projectDetails } = selectedProject;
  const isDRAFT = projectDetails?.project_status === ProjectStatusEnum.Draft;
  const isUnderDevelopment = projectDetails?.project_status === ProjectStatusEnum.UnderDevelopment;
  const { has_biodiversity_module, sites } =
    projectDetails || {};
  // const { biodiversityProjectAnalysis } = state.selectedProject;

  // const [filterSpeciesData, setFilterSpeciesData] = useState(biodiversityProjectAnalysis?.credits);
  const [draftView, setDraftView] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (isDRAFT) {
      setDraftView(true);
      return;
    }
    if (isUnderDevelopment && has_biodiversity_module && sites?.length && id) {
      // fetch data 
      setLoading(true);
      setError(null);
      clientService.api
        .readBiodiversityProjectSummaryApiV1ProjectsProjectIdBiodiversitySummaryGet(id)
        .then((response) => {
          startTransition(() => {
            dispatch({
              type: 'SET_PROJECT_BIODIVERSITY_ANALYSIS',
              payload: response.data,
            });
          });
          // setFilterSpeciesData(response.data.credits);
          setLoading(false);
          setError(null);
        })
        .catch((apiError) => {
          console.error('Failed to fetch bio diversity analysis details:', apiError);
          const errorMessage =
            apiError.response?.data?.detail ||
            `Failed to load bio diversity analysis details for ID: ${id}.`;
          setError(errorMessage);
          showSnackbar({
            message: 'Error fetching bio diversity analysis details.',
            type: snackbarType.ERROR,
          });
          setLoading(false);
        });
    }
  }, [id]);

  if (draftView) {
    return (
      <SubscriptionLock
        message="Register your project with us to unlock advanced features and insights."
        ctaLabel="Register Project"
        onCtaClick={() => window.open('https://calendly.com/jaya-kandir-darukaa/new-meeting', '_blank')}
        previewChartType='bar'
      />
    );
  }

  if (loading) {
    return (
      <FullPageLoader
        title="Just a moment, crafting your project view..."
        message="Almost there..."
      />
    );
  }
  if (error) {
    return (
      <FullPageMessage
        headline="Uh-oh! The project data took an unexpected detour."
        subHeadline={`We're having a little trouble loading the details. The system reports: ${error}`}
        ctaText="Go to Home"
        onCtaClick={() => {
          window.location.href = '/';
        }}
        ctaIcon={<Home />}
      />
    );
  }

  // const filterSpeciesData = biodiversityProjectAnalysis?.credits;
  // const chartData1 = [
  //   {
  //     name: 'July 2023',
  //     value1: filterSpeciesData?.historical_credits_retirement[0]['July 2023'],
  //   },
  //   {
  //     name: 'October 2023',
  //     value1: filterSpeciesData?.historical_credits_retirement[0]['October 2023'],
  //   },
  //   {
  //     name: 'December 2023',
  //     value1: filterSpeciesData?.historical_credits_retirement[0]['December 2023'],
  //   },
  //   {
  //     name: 'February 2024',
  //     value1: filterSpeciesData?.historical_credits_retirement[0]['February 2024'],
  //   },
  //   {
  //     name: 'August 2024',
  //     value1: filterSpeciesData?.historical_credits_retirement[0]['August 2024'],
  //   },
  // ];
  // const creditIssue = filterSpeciesData ? filterSpeciesData['overall_issued/retired'][0] : {};
  // const chartData2 = [
  //   { name: 'Retired Credits', value1: creditIssue.retired },
  //   { name: 'Issued Credits', value1: creditIssue.issued },
  // ];
  // const creditCardData = [
  //   {
  //     label: 'Total Credits',
  //     value: filterSpeciesData?.total_credits_over_crediting_period,
  //     xs: 4,
  //     sm: 2.6,
  //   },
  //   {
  //     label: 'Average Price Per Credit',
  //     value: filterSpeciesData?.average_price_per_credit,
  //     xs: 4,
  //     sm: 2.6,
  //   },
  //   {
  //     label: 'Credits Available For Sale',
  //     value: filterSpeciesData?.credits_available_for_sale,
  //     xs: 4,
  //     sm: 2.6,
  //   },
  //   { label: 'Credits Retired', value: filterSpeciesData?.credit_retired, xs: 4, sm: 2.6 },
  // ];
  return (
    <Box sx={{ mt: 5 }}>
      <Box
        sx={{
          maxHeight: '400px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          padding: '10px',
          backgroundColor: '#fff',
          margin: '15px 1px',
          borderRadius: '8px',
          boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important',
        }}
      >
        {/* <CreditCard data={creditCardData} /> */}
      </Box>
      {/* <Box sx={{ mt: 1 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <ChartComponent
              chartType={'column'}
              chartTitle={'Historical Credits Retirement'}
              data={chartData1}
              title="Credit Retired"
              seriesValue1="Credits"
              yTitle="Month Year"
            />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <ChartComponent
              chartType={'donut'}
              chartTitle={'Overall Issued/Retired Credits'}
              data={chartData2}
            />
          </Grid>
        </Grid>
      </Box> */}
    </Box>
  );
};

export default BiodiversityCreditDetail;
